import { object, string } from 'yup';

export default object().shape({
  addressLine1: string().required(),
  addressLine2: string(),
  postalCode: string().required(),
  city: string().required(),
  country: object().nullable().required(),
});
